// extracted by mini-css-extract-plugin
export default {"container":"lorem_container__2787E","poutine":"lorem_poutine__274m6","inner":"lorem_inner__3lEAc","top":"lorem_top__3d23u","bottom":"lorem_bottom__2SD12","stat":"lorem_stat__3av4t"};